import { FaqHelpList } from './types'

export const FaqHelpListData: FaqHelpList[] = [
  { name: 'Restaurants', value: 'Restaurant List', icon: 'ph:shopping-cart' },
  { name: 'Menu', value: 'Menu Service', icon: 'material-symbols:menu-book-outline' },
  { name: 'GuestExperience', value: 'Customer Services', icon: 'ant-design:customer-service-outlined' },
  { name: 'Marketing', value: 'Marketing List', icon: 'nimbus:marketing' },
  { name: 'Operations', value: 'Operations', icon: 'mdi:truck-outline' },
  { name: 'UserAccess', value: 'Users', icon: 'streamline:user-multiple-group' }
]
